import { useAppDispatch } from '@/Application/Hooks/Redux';
import { setPaymentError } from '@/modules/perseo-billing/store/slices/billing';

import type { IErrorResponse } from '../utils/error-handler';
import { errorHandlerBilling } from '../utils/error-handler';

import { useGtmBillingProduct } from './use-gtm-billing';

export const usePaymentError = () => {
  const dispatch = useAppDispatch();
  const { sendPaymentErrorGtm } = useGtmBillingProduct();

  const handlePaymentError = (error?: IErrorResponse) => {
    const billingError = errorHandlerBilling(error);

    dispatch(setPaymentError(billingError));
    sendPaymentErrorGtm(billingError);
  };

  return {
    handlePaymentError
  };
};
